import { render, staticRenderFns } from "./UrgencyAndImpact.vue?vue&type=template&id=330e55d9&scoped=true&"
import script from "./UrgencyAndImpact.vue?vue&type=script&lang=js&"
export * from "./UrgencyAndImpact.vue?vue&type=script&lang=js&"
import style0 from "./UrgencyAndImpact.vue?vue&type=style&index=0&id=330e55d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330e55d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCol,VIcon,VRow,VToolbar,VToolbarTitle})
